const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    mdl: 1024,
    lg: 1280,
    xl: 1440,
  },
};

export default breakpoints;
